<template>
  <div class="carousel">
    <swiper
      :modules="modules"
      :slides-per-view="1"
      :pagination="paginationOutsideOpts"
      :loop="loopLocal"
      :spaceBetween="spaceBetween"
      :watchOverflow="true"

      :watchSlidesProgress="true"
      :breakpoints="breakpoints"
      @swiper="setSwiperRef"
    >
      <slot :swiperNextSlide="swiperNextSlide" :swiperPrevSlide="swiperPrevSlide"/>
    </swiper>
    <div ref="paginaton" :class="`swiper-pagination swiper-pagination-outside-${uuid}`"></div>
    <div v-if="swiperRef && loopLocal" class="carousel__nav">
      <button type="button" @click="swiperPrevSlide" class="carousel__prev">
        <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 2L2 9L9 16" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <button type="button" @click="swiperNextSlide" class="carousel__next">
        <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 2L9 9L2 16" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
  </div>

</template>
<script setup>
import { ref, getCurrentInstance, computed } from 'vue';
import { Navigation, Pagination } from "swiper";

const modules = [Navigation, Pagination];

const breakpoints = {
  320: {
    slidesPerView: 'auto',
    spaceBetween: 20,
  },
  768: {
    slidesPerView: 3,
    spaceBetween: 20,
  },
  1024: {
    slidesPerView: 3,
    spaceBetween: 33,
  },
  1400: {
    slidesPerView: 3,
    spaceBetween: 33,
  }
}

const instance = getCurrentInstance()
const uuid = ref(instance.uid)

const props = defineProps({
  navigation: {
    type: Boolean,
    default: false
  },
  loop: {
    type: Boolean,
    default: true
  },
  spaceBetween: {
    type: Number,
    default: 10
  },
  slidesLength: {
    type: Number,
    default: 1
  }
});

  const paginationOutsideOpts =  {
    el: `.swiper-pagination-outside-${uuid.value}`,
    clickable: true
  };

const currentBreakpoint =  computed(() => {
  let currentBreakpoint = 0;
  Object.keys(breakpoints).forEach(breakpoint => {
      if (window.innerWidth >= breakpoint) {
        currentBreakpoint = breakpoints[breakpoint];
      }
  });

  return currentBreakpoint;
})

const loopLocal = computed(() => {
  return props.loop && props.slidesLength > currentBreakpoint.value.slidesPerView;
})

let swiperRef = ref(null);

const setSwiperRef = (swiper) => {
  swiperRef.value = swiper;
};

const swiperPrevSlide = () => {
  swiperRef.value.slidePrev()
}

const swiperNextSlide = () => {
  swiperRef.value.slideNext()
}

</script>
